import * as React from "react";
import { FeedItemYourEntry } from "../../../server/feed/buildfeed";
import { FeedElementContainer } from "../DesignSystem/formatting/FeedComponents";
import { RLink } from "../DesignSystem/RLink";
import { HeartIcon, PlayIcon } from "@heroicons/react/24/solid";
import { Countdown } from "../DesignSystem/Countdown";

export const FeedElementYourEntry = ({ item }: { item: FeedItemYourEntry }) => {
  const resultsNotOut = new Date(item.judging_stop) > new Date();

  return (
    <FeedElementContainer
      href={`/entry/${item.entry.id}`}
      icon={"music"}
      title={
        <>
          <RLink white to={"/entry/" + item.entry.id}>{item.entry.title}</RLink>
        </>
      }
      subtitle={
        <div>
          {item.entry.overall_score ? (
            <span>
              {item.entry.overall_score} |{" "}
              <RLink to={"/entry/" + item.entry.id}>See all your scores!</RLink>
            </span>
          ) : (
            <span>
              {item.entry.hearts > 0 && (
                <span title="Favorites">
                  <HeartIcon className="inline h-4 w-4 text-red-400" />{" "}
                  {item.entry.hearts}
                </span>
              )}
              {item.entry.hearts > 0 && item.entry.plays > 0 && " · "}
              {item.entry.plays > 0 && (
                <span title="Plays">
                  <PlayIcon className="inline h-4 w-4 text-slate-400" />{" "}
                  {item.entry.plays}
                </span>
              )}
              {(item.entry.hearts > 0 || item.entry.plays > 0) && resultsNotOut && " · "}
              {resultsNotOut && (
                <span>
                  <Countdown dark minimal until={new Date(item.judging_stop)} /> until results
                </span>
              )}
            </span>
          )}
          {item.entry.overall_score && !resultsNotOut && (
            <span>
              {" "}
              | <RLink to={`/entry/${item.entry.id}`}>See your results</RLink>
            </span>
          )}
          {!item.entry.overall_score && !resultsNotOut && (
            <span>
              <RLink to={`/entry/${item.entry.id}`}>See your results</RLink>
            </span>
          )}
        </div>
      }
    ></FeedElementContainer>
  );
};
